/**
 * Hero Swiper: Infinite Loop, Autoplay, Pills in Sync mit bestehenden Styles.
 * Swiper-Bundle muss vor diesem Script geladen sein.
 */
(function () {
  function initHeroSwipers() {
    if (typeof Swiper === 'undefined') return;

    document.querySelectorAll('[data-hero-swiper]').forEach(function (el) {
      if (el.swiper) return;

      var autoplayMs = parseInt(el.getAttribute('data-autoplay'), 10) || 4000;
      var pills = el.querySelectorAll('[data-hero-pill]');

      var swiper = new Swiper(el, {
        effect: 'fade',
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        speed: 400,
        allowTouchMove: true,
        grabCursor: false,
        autoplay: {
          delay: autoplayMs,
          disableOnInteraction: false,
        },
        on: {
          init: function () {
            updatePills(this, pills);
          },
          slideChange: function () {
            updatePills(this, pills);
          },
        },
      });

      pills.forEach(function (pill, index) {
        pill.addEventListener('click', function () {
          swiper.slideToLoop(index);
        });
      });

      el.swiper = swiper;
    });
  }

  function updatePills(swiper, pills) {
    var realIndex = swiper.realIndex;
    pills.forEach(function (pill, i) {
      pill.setAttribute('aria-selected', i === realIndex ? 'true' : 'false');
    });
    var activeSlide = swiper.slides && swiper.slides[swiper.activeIndex];
    var list = swiper.slides || [];
    for (var i = 0; i < list.length; i++) {
      var slide = list[i];
      var slideEl = slide.querySelector && slide.querySelector('slideshow-slide');
      if (slideEl) slideEl.setAttribute('aria-hidden', slide === activeSlide ? 'false' : 'true');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeroSwipers);
  } else {
    initHeroSwipers();
  }

  document.addEventListener('shopify:section:load', initHeroSwipers);
})();
